import styled, { css } from 'styled-components';
import { layout, border, space, position, typography, variant, color, flexbox } from 'styled-system';

export const Button = styled.button`
  ${({ theme, disabled }) => css`
    border: none;
    cursor: pointer;
    font-family: 'Diatype';
    font-weight: 500;
    padding: 0;
    white-space: nowrap;
    color: ${theme.color.gray[500]};

    background-color: transparent;

    ${variant({
      variants: {
        primary: {
          backgroundColor: theme.color.mintMinded[900],
          color: theme.color.white,
          borderRadius: '2px',
        },
        secondary: {
          color: theme.color.gray[500],
          border: `1px solid ${theme.color.gray[400]}`,

          svg: {
            path: {
              fill: theme.color.black,
            },
          },

          '&:hover': {
            backgroundColor: theme.color.mintMinded[900],
            border: `1px solid ${theme.color.mintMinded[900]}`,
            color: theme.color.white,

            svg: {
              path: {
                fill: theme.color.white,
              },
            },
          },
        },
        tertiary: {
          backgroundColor: theme.color.mintMinded[200],

          '&:hover': {
            backgroundColor: theme.color.mintMinded[900],
            color: theme.color.white,

            div: {
              p: {
                color: theme.color.white,
              },
            },

            svg: {
              path: {
                fill: theme.color.white,
              },
            },
          },
        },
        burger: {
          backgroundColor: theme.color.mintMinded[900],
        },
      },
    })}

    ${color}
    ${position}
    ${typography}
    ${border}
    ${layout}
    ${space}
    ${flexbox}

    ${disabled &&
    `
      background-color: ${theme.color.gray[100]}; 
      color: ${theme.color.white};
      border: 1px solid ${theme.color.gray[100]};

      &:hover {
        background-color: ${theme.color.gray[100]};
        border: 1px solid ${theme.color.gray[100]};
        color: ${theme.color.white};

        svg path {
          fill: ${theme.color.white};
        }
      }
    `}
  `}
`;
